import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const routeTitleMap: Record<string, string> = {
  // '/login': 'Login',
  '/deliveries': 'Deliveries',
  '/deliveries/add': 'Add Delivery',
  '/rob': 'ROB',
  '/rob/add': 'Add ROB',
  '/lubricants/products': 'Lubricant Products',
  '/lubricants/categories': 'Lubricant Categories',
  '/lubricants/types': 'Lubricant Types',
  '/lubricants/groups': 'Lubricant Groups',
  '/extra-costs': 'Extra Costs',
  '/companies/makers': 'Makers',
  '/companies/suppliers': 'Suppliers',
  '/companies/customer': 'Customer',
  '/lubrication-charts': 'Lubrication Charts',
  '/lubrication-view': 'View Lubrication',
  '/lubrication-edit': 'Edit Lubrication',
  '/management-periods': 'Management Periods',
  '/price-list': 'Price List',
  '/price-list-details': 'Price List Details',
  '/type-in-lubricants': 'Type In Lubricants',
};

const defaultTitle = 'Lubricants Portal';

export const useDocumentTitle = () => {
  const location = useLocation();

  useEffect(() => {
    let title = defaultTitle;

    // Exact match
    if (routeTitleMap[location.pathname]) {
      title = `${routeTitleMap[location.pathname]} | ${defaultTitle}`;
    } else {
      // Dynamic routes matching
      if (location.pathname.startsWith('/deliveries/edit/')) {
        title = `Edit Delivery | ${defaultTitle}`;
      } else if (location.pathname.startsWith('/rob/edit/')) {
        title = `Edit ROB | ${defaultTitle}`;
      } else if (location.pathname.startsWith('/lubrication-view/')) {
        title = `View Lubrication | ${defaultTitle}`;
      } else if (location.pathname.startsWith('/lubrication-edit/')) {
        title = `Edit Lubrication | ${defaultTitle}`;
      } else if (location.pathname.startsWith('/price-list-details/')) {
        title = `Price List Details | ${defaultTitle}`;
      }
    }

    document.title = title;
  }, [location.pathname]);
};
